import * as THREE from 'three';

import * as mutationTypes from '../mutation-types';

const state = () => ({
  loaders: {
    texture: new THREE.TextureLoader(),
  },
  textures: [],
  selectedTexture: null,
  colors: [
    '#000',
    '#fff',
    '#CBD5E0',
    '#E2E8F0',
    '#C53030',
    '#F56565',
    '#48BB78',
    '#2F855A',
    '#4299E1',
    '#2B6CB0',
    '#F6E05E',
    '#FBD38D'
  ],
  selectedColor: '#ffffff',
});

const getters = {
  textureLoader: state => state.loaders.texture,
  textures: state => state.textures,
  textureById: state => (id) => {
    return state.textures.filter(t => t.img_id === id)[0];
  },
  selectedTexture: state => state.selectedTexture,
  colors: state => state.colors,
  selectedColor: state => state.selectedColor,
};

const mutations = {
  [mutationTypes.SET_SELECTED_COLOR] (state, color) {
    state.selectedColor = color;
  },
  [mutationTypes.RESET_TEXTURES] (state, mesh) {
    state.selectedTexture = null;

    if(mesh.material.userData.texture) {
      mesh.material.userData.texture = null;
      mesh.material.map = null;
      mesh.material.needsUpdate = true;
    }

    if(mesh.userData.backMesh) {
      mesh.userData.backMesh.material.map = null;
      mesh.userData.backMesh.material.needsUpdate = true;
    }

    // console.log('reset texture mutation');

  },
  [mutationTypes.SET_SELECTED_TEXTURE] (state, texture) {
    // console.log('must set texture',texture);
    state.selectedTexture = texture;
  },
  [mutationTypes.INIT_TEXTURES] (state,textures) {
    state.textures = textures;
  }
};

const actions = {
  // todo setColor

  resetTexture: ({commit},payload) => {
    commit(mutationTypes.RESET_TEXTURES,payload);
  },

  setSelectedTexture: async ({ commit, dispatch, rootGetters }, payload ) => {

    // console.log('Set selected texture');

    const mesh = rootGetters['clothes/selectedMesh'];

    if(!mesh.id) {
      return;
    }

    if( !payload.inst || !(payload.inst instanceof THREE.Texture) ) {
      await dispatch('uploadTexture',payload);
    }

    let colorHexString = '#ffffff';
    let color = new THREE.Color(colorHexString);

    if(mesh.userData.backMesh) {
      mesh.userData.backMesh.material.color = color;
      mesh.userData.backMesh.material.map = payload.inst;
      mesh.userData.backMesh.material.needsUpdate = true;
    }
    mesh.material.color = color;
    mesh.material.map = payload.inst;
    mesh.material.needsUpdate = true;


    //check if texture is same product of prev selected texture
    if(mesh.material.userData.texture) {

      let type = mesh.material.userData.texture.title.split('-')[0];

      // if type is not equal reset transformation settings
      if(type !== payload.title.split('-')[0]) {

        mesh.material.userData.uniforms.tScale.value = 1.0;
        mesh.material.userData.uniforms.tRotation.value = 0.0;
        mesh.material.userData.uniforms.tOffsetX.value = 0.0;
        mesh.material.userData.uniforms.tOffsetY.value = 0.0;

      }

    }

    mesh.material.userData.texture = payload;
    mesh.material.userData.color = color;

    //modifica i valori di repeat x e y in base alle dimensioni e alle proporzioni reali della texture
    if(mesh.material.userData.uniforms) {

      if(payload.width_cm && payload.height_cm) {

        mesh.material.userData.uniforms.repeatX.value = 25 / payload.width_cm; //uv map 25x25 cm
        mesh.material.userData.uniforms.repeatY.value = 25 / payload.height_cm ; //uv map 25x25 cm

      } else if(payload.dpcm) {

        let height = payload.inst.img.height / payload.dpcm;
        let width = payload.inst.img.width / payload.dpcm;

        mesh.material.userData.uniforms.repeatX.value = 25 / width; //uv map 25x25 cm
        mesh.material.userData.uniforms.repeatY.value = 25 / height; //uv map 25x25 cm

      }

    }
    
    commit(mutationTypes.SET_SELECTED_COLOR,colorHexString);
    commit(mutationTypes.SET_SELECTED_TEXTURE,payload);
    return payload;

  },
  // todo texturesPreloading
  uploadTexture: ({ state }, payload) => {
    return new Promise((resolve,reject) => {
      try {

        state.loaders.texture.load(payload.src,(texture) => {
          payload.inst = texture;
          texture.wrapT = texture.wrapS = THREE.RepeatWrapping;
          // texture.repeat.set( payload.repeat.x, payload.repeat.y );
          resolve(payload);
        });

      } catch(e) {
        reject(`An error occurred: ${e}.`);
      }
    })
  },
  setSelectedColor: ({ commit }, payload) => {
    // console.log('setSelectedColor',payload);
    commit(mutationTypes.SET_SELECTED_COLOR,payload);
    // commit(mutationTypes.SET_SELECTED_TEXTURE,null);
    // commit(mutationTypes.RESET_TEXTURES,rootGetters['clothes/selectedMesh']);
  },
  setTextureScale: ({ rootGetters }, payload) => {

    // console.log(rootGetters['snapshots/snapshots']);

    return new Promise( (resolve, reject) => {

      try {

        if(payload > 2.0 || payload < 0.25) {
          reject('Value not allowed');
        }

        if( rootGetters['clothes/selectedMesh'] ) {
          let material = rootGetters['clothes/selectedMesh'].material;
          material.needsUpdate = true;
          resolve(material.userData.uniforms);
        }

      } catch (e) {
        reject(`An error occurred: ${e}.`);
      }

    })

  },
  setTextureRotation: ({ rootGetters }, payload) => {
    return new Promise( (resolve,reject) => {
      try {

        if( typeof payload != 'number' && payload > 180 && payload < -180) {
          reject('Value not allowed');
        }

        if( rootGetters['clothes/selectedMesh'] ) {
          let material = rootGetters['clothes/selectedMesh'].material;
          material.needsUpdate = true;
          resolve(material.userData.uniforms);
        }

      } catch (e) {
        reject(`An error occurred: ${e}.`);
      }
    })
  },
  setTextureOffset: ({ rootGetters }, payload) => {
    return new Promise( (resolve,reject) => {
      try {

        if( typeof payload.x != 'number' || typeof payload.y != 'number') {
          reject('Value not allowed');
        }

        if( rootGetters['clothes/selectedMesh'] ) {
          let material = rootGetters['clothes/selectedMesh'].material;
          material.needsUpdate = true;
          resolve(material.userData.uniforms);
        }

      } catch (e) {
        reject(`An error occurred: ${e}.`);
      }
    })
  },
  initTextures: ({ commit, dispatch },payload) => {

    return new Promise( (resolve,reject) => {
      commit(mutationTypes.INIT_TEXTURES,payload);

      try {

        dispatch('texturesPreloading').then(() => {
          resolve();
        })

      }catch (e) {
        reject(`An error occurred: ${e}.`);
      }

    });

  },
  disposeTexture: (_, payload) => {
    //receive the texture and call the dispose method,
    payload.dispose();
    payload = null;
    // console.log('texture dispoase: ',payload);
  },
  texturesPreloading: async ({ state, dispatch }) => {
    // console.log('preloading textures',state.textures.filter(el => !el.inst).length);
    state.textures.forEach( async el => {
      if(!el.inst)
        await dispatch('uploadTexture',el);
      // await dispatch('uploadDress',el);
    });

    // console.log(state.textures);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}